import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import ModalSearchUser from "@dropDesk/presentation/components/modals/modal_search_user";
import {useNavigate} from "react-router-dom";
import {
    useModalsReportTicketEvaluations
} from "@dropDesk/presentation/pages/ticket/evaluation/ui/search/modals/handle_change_visible";


const ModalsReportTicketEvaluations = observer(
    ({
         onSelectContact,
         onSelectAttendant,
     }: {
         onSelectContact: (contact: UserEntity) => void,
         onSelectAttendant: (attendant: UserEntity) => void,
     }
    ) => {

        const {
            visibleModalSearchAttendant, setVisibleModalSearchAttendant,
            visibleModalSearchContacts, setVisibleModalSearchContacts,
        } = useBetween(useModalsReportTicketEvaluations);

        const navigate = useNavigate();

        return (
            <>
                {visibleModalSearchAttendant && <ModalSearchUser
                    visible={visibleModalSearchAttendant}
                    onClose={() => setVisibleModalSearchAttendant(false)}
                    role={UserRole.attendant}
                    handleSelectUser={async (user) => {
                        onSelectAttendant(user);
                        setVisibleModalSearchAttendant(false);
                    }}
                    textHeaderModal={"Pesquisa de Atendentes"}
                    labelNoResults={"Nenhum usuário encontrado na pesquisa"}
                    inputSearchPlaceholder={"Pesquise por atendentes"}
                />}

                {visibleModalSearchContacts && <ModalSearchUser
                    visible={visibleModalSearchContacts}
                    onClose={() => setVisibleModalSearchContacts(false)}
                    role={UserRole.userClient}
                    handleSelectUser={async (user) => {
                        onSelectContact(user);
                        setVisibleModalSearchContacts(false);
                    }}
                    textHeaderModal={"Pesquisa de Contatos"}
                    labelNoResults={"Nenhum contato encontrado na pesquisa"}
                    inputSearchPlaceholder={"Pesquise por contatos"}
                />}

            </>
        )
    })
export default ModalsReportTicketEvaluations;
